// extracted by mini-css-extract-plugin
export default {"scrollInputArea":"scrollInputArea_3M9ix","inputArea":"inputArea_2DjmF","pre":"pre_2EVT4"};